// @flow
import React, {useEffect, useState, useRef, useCallback} from "react";
import {useHistory} from "react-router-dom";
import {useObserver} from "mobx-react-lite";
import {EditOutlined, CheckOutlined} from "@ant-design/icons";
import moment from "moment";
import {Descriptions, Col, Skeleton, Row, Button, Tabs, Tooltip, Tag} from "antd";
import {useTranslation} from "react-i18next";
import placeholder from "../../../public/images/person-placeholder.jpg";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {useCodPaymentBrandLabel} from "../../../hooks/useCodPaymentBrandLabel";
import useIsFocused from "../../../hooks/useIsFocused";
import CourierDocumentsDownload from "./courierOnboardingTab/courierDocuments/CourierDocumentsDownload";
import {
    ImageProfile,
    LeftButton,
    TabsContainer,
    TopContainer,
    EditButton,
    SelectContainer,
    CourierPersonalInfoContainer,
    CourierPersonalInfoItem,
    PersonalInfoCard,
    ImageWrapper,
    Overlay,
    PhotoTabs
} from "./courierDetailStyles";
import {CourierStatusUpdateModal} from "../../_defaultComponents/CourierStatusUpdateModal/CourierStatusUpdateModal";
import {ChangePasswordModal} from "../../_defaultComponents/ChangePasswordModal/ChangePasswordModal";
import {MultipleSelect} from "../../_defaultComponents/MultipleSelect/MultipleSelect";
import {allowChangeStatuses} from "../../../constants/constants";
import {formatPhoneNumber} from "../../../utils/helpers";
import {LogTable} from "./courierLogTable";
import {CourierStatusLogTable} from "./courierStatusLogTable";
import {ShiftTable} from "./courierShiftTable";
import {CourierOnboardingTab} from "./courierOnboardingTab/CourierOnboardingTab";
import {CourierCodPaymentTab} from "./courierCodPaymentTab/CourierCodPaymentTab";
import {CourierInfoRow} from "./courierInfoRow/CourierInfoRow";
import {CourierOnboardingActionButtons} from "./courierOnboardingActionButtons/CourierOnboardingActionButtons";
import CreateGetirPicture from "./courierOnboardingTab/courierDocuments/CreateGetirPicture";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {CourierContractsTab} from "./courierContractsTab/CourierContractsTab";
import {HistoryTab} from "./components/HistoryTab";
import {CourierWalletTab} from "./courierWalletTab/CourierWalletTab";
import {OwnerTicketsTab} from "../../tickets/common/OwnerTicketsTab";

export const CourierDetail = ({courierId}) => {
    const stores = useStore();
    const codPaymentBrandLabel = useCodPaymentBrandLabel();
    const isAgency = stores.meStore.checkRole("isAgency");
    const history = useHistory();
    const isFocused = useIsFocused();
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
    const {t, i18n} = useTranslation([
        "courierDetail",
        "mapCourierStatuses",
        "courierTypes",
        "deliveryStatuses",
        "orderStatuses",
        "courierStatuses",
        "paymentTypes",
        "courierLogTable",
        "activationSteps",
        "courierContracts"
    ]);
    const [courierStatus, setCourierStatus] = useState("");
    const [courierSelectData, setCourierSelectData] = useState();
    const [courierLogs, setCourierLogs] = useState(null);
    const [dateRange, setDateRange] = useState([]);
    const [currentDelivery, setCurrentDelivery] = useState(null);
    const [tabKey, setTabKey] = useState("courierInformationTab");
    const [recall, setRecall] = useState(true);
    const [visibleStatusModal, setVisibleStatusModal] = useState(false);
    const [visibleChangePasswordModal, setVisibleChangePasswordModal] = useState(false);
    const [orderInfoVisible, setOrderInfoVisible] = useState({});
    const [disableEditDedication, setDisableEditDedication] = useState(true);
    const canManageGetirPicture = stores.meStore.checkRole("createGetirPicture");
    const [dedicationPagination, setDedicationPagination] = useState({
        skip: 0,
        limit: 10,
        page: 1
    });
    const [onboardingStatusHistoryPagination, setOnboardingStatusHistoryPagination] = useState({
        skip: 0,
        limit: 10,
        page: 1
    });
    const recallRef = useRef(recall);
    recallRef.current = recall;

    const reloadCourier = useCallback((switchToWalletTab = false) => {
        setRecall(!recallRef.current);
        if (switchToWalletTab) {
            setTabKey("courierWalletTab");
        }
    }, []);
    const [loading, courierData, setData, setLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getCourier.bind(null, {
            courierId
        }),
        dependencies: [recall]
    });

    const [
        currentDeliveryloading,
        currentDeliveryData,
        setcurrentDelivery,
        setcurrentDeliveryLoading
    ] = useFetch({
        defaultDataValue: null,
        fetchFn: stores.courierStore.getCurrentDelivery.bind(null, {
            courierId
        }),
        dependencies: [recall]
    });

    const [
        dedicationDataLoading,
        courierDedicationData,
        setCourierDedicationData,
        setDedicationDataLoading
    ] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.courierDedicationLog.bind(null, {
            courierId,
            skip: dedicationPagination.skip,
            limit: dedicationPagination.limit
        }),
        dependencies: [recall, dedicationPagination.skip, dedicationPagination.limit],
        initialCall: !stores.meStore.checkRole("isCompanyUser")
    });
    const [
        onboardingStatusHistoryDataLoading,
        onboardingStatusHistoryData,
        setOnboardingStatusHistoryData,
        setOnboardingStatusHistoryDataLoading
    ] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getCourierOnboardingStatusLogs.bind(null, {
            courierId,
            skip: onboardingStatusHistoryPagination.skip,
            limit: onboardingStatusHistoryPagination.limit
        }),
        dependencies: [
            recall,
            onboardingStatusHistoryPagination.skip,
            onboardingStatusHistoryPagination.limit
        ]
    });
    const handleDedicationPaginationChange = paginationParams => {
        setDedicationPagination(prev => ({
            ...prev,
            ...paginationParams
        }));
    };
    const handleOnboardingStatusHistoryPaginationChange = paginationParams => {
        setOnboardingStatusHistoryPagination(prev => ({
            ...prev,
            ...paginationParams
        }));
    };

    useEffect(() => {
        if (isFocused) {
            let timeout = null;
            if (tabKey === "courierLatestStatusTab") {
                timeout = setTimeout(() => {
                    setRecall(!recallRef.current);
                }, 2000);
            } else {
                clearTimeout(timeout);
                timeout = null;
            }
            return () => clearTimeout(timeout);
        }
    }, [tabKey, recall, isFocused]);

    useEffect(() => {
        if (courierData.status && courierData.status !== 200) {
            stores.appStore.openErrorModal({
                content: courierData.data.message,
                onOk: () => {
                    history.push("/couriers");
                }
            });
        }

        let statusValue = courierData?.data?.location?.status;
        if (statusValue === "ready") {
            statusValue = "available";
        }
        if (courierData?.data?.location?.deliveryState) {
            if (courierData?.data?.location?.deliveryState.includes("PickUp")) {
                statusValue = "busyOnPickup";
            }
            if (courierData?.data?.location?.deliveryState.includes("Delivery")) {
                statusValue = "busyOnDelivery";
            }
            if (courierData?.data?.location?.deliveryState.includes("Return")) {
                statusValue = "busyOnReturn";
            }
            if (courierData?.data?.location?.deliveryState.includes("Transfer")) {
                statusValue = "busyOnTransfer";
            }
        }

        setCourierStatus(statusValue || "unavailable");
    }, [courierData]);

    useEffect(() => {
        setCurrentDelivery(currentDeliveryData);
    }, [currentDeliveryData]);

    useEffect(() => {
        if (stores.meStore.checkRole("isCompanyUser")) return;
        setInitialCourierLogs();
    }, []);

    const setInitialCourierLogs = async () => {
        let start = new Date(Date.now() - 1000 * 60 * 60 * 24 * 2);
        start.setHours(0, 0, 0, 0);
        const result = await stores.courierStore.getCourierStatusLogs({
            courierId,
            startDate: start,
            endDate: new Date()
        });
        setCourierLogs(result);
    };

    const updateStatus = async values => {
        const {note, status} = values;
        if (allowChangeStatuses.has(courierStatus)) {
            await stores.courierStore.updateStatus({
                note,
                status: status === "available" ? courierData.data.defaultStatus : status,
                courierId
            });
            await setRecall(!recallRef.current);
            await setVisibleStatusModal(!visibleStatusModal);
        } else {
            stores.appStore.openErrorModal({
                content: t("updateCourierStatusWarning", {ns: "courierDetail"}),
                onOk: () => {
                    setVisibleStatusModal(!visibleStatusModal);
                }
            });
        }
    };

    const updateCourierPassword = async values => {
        const {newPassword, passwordConfirm} = values;
        await setRecall(!recallRef.current);
        setVisibleChangePasswordModal(!visibleChangePasswordModal);
        await stores.courierStore.changePassword({
            newPassword,
            courierId
        });
    };

    const onChangeMultipleSelect = e => {
        setCourierSelectData(e);
    };

    const handleDownloadGetirImage = (url, fileName) => {
        try {
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            stores.appStore.openErrorModal({
                content: "Getir görseli indirilemedi"
            });
        }
    };

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return useObserver(() => {
        const profilePictureUrl = courierData?.data?.documents?.profilePicture?.publicUrl;
        const getirPictureUrl = courierData?.data?.getirImage;
        const defaultProfilePhoto = courierData?.data?.photo;
        const profilePhotoSrc = profilePictureUrl || defaultProfilePhoto || placeholder;
        const courierTckn = courierData?.data?.tckn;
        const basePhotoForGetirCreation = profilePictureUrl || defaultProfilePhoto;
        return (
            <>
                <CourierInfoRow
                    courier={courierData?.data || {}}
                    reloadCourier={() => setRecall(!recallRef.current)}
                    isMobile={isMobile}
                />
                <TabsContainer
                    data-testid="curierDetailScreen"
                    activeKey={tabKey}
                    onChange={key => {
                        setTabKey(key);
                    }}
                    tabBarExtraContent={
                        stores.meStore.checkRole("notVisibleForCompanyUser") &&
                        courierData.data && (
                            <Row
                                type="flex"
                                data-testid="courierActionButtons"
                                style={{columnGap: "8px"}}
                            >
                                <Col className="courierDetailActionButtons">
                                    {stores.meStore.checkRole("updateCourier") &&
                                        stores.meStore.checkPermission("couriers.edit") && (
                                            <LeftButton
                                                type="primary"
                                                href={"/couriers/edit/" + courierId}
                                                data-testid="courierUpdateButton"
                                                onClick={event => {
                                                    event.preventDefault();
                                                    history.push("/couriers/edit/" + courierId);
                                                }}
                                                icon={<EditOutlined />}
                                            >
                                                {t("actions.updateCourier", {ns: "courierDetail"})}
                                            </LeftButton>
                                        )}{" "}
                                    {/*  {stores.meStore.checkRole("updateCourier") && (
                                    <LeftButton
                                        type="primary"
                                        onClick={() => {
                                            setVisibleChangePasswordModal(true);
                                        }}
                                        icon={<LockOutlined />}
                                    >
                                        {t("actions.updateCourierPassword", {
                                            ns: "courierDetail"
                                        })}
                                    </LeftButton>
                                )} */}
                                </Col>
                                {/* <Col className="courierDetailActionButtons">
                                    {stores.meStore.checkRole("updateCourierActivations") &&
                                        (courierData.data?.disabled !== false) && (
                                        <Tooltip
                                            title={
                                                !courierData.data
                                                    ? "Kurye bulunamadı"
                                                    : !["approved"].includes(
                                                          courierData.data.activationStep
                                                      )
                                                    ? "Kurye henüz onaylanmamış"
                                                    : ""
                                            }
                                        >
                                            <LeftButton
                                                disabled={
                                                    !courierData.data ||
                                                    !["approved"].includes(
                                                        courierData.data.activationStep
                                                    )
                                                }
                                                type={"primary"}
                                                danger
                                                data-testid="courierActiveInActiveButton"
                                                data-testvalue={
                                                    courierData.data.disabled
                                                        ? "inactive"
                                                        : "active"
                                                }
                                                onClick={() => {
                                                    updateCourierDisable();
                                                }}
                                                icon={
                                                    courierData.data.disabled ? (
                                                        <CheckOutlined />
                                                    ) : (
                                                        <CloseOutlined />
                                                    )
                                                }
                                            >
                                                {courierData.data.disabled
                                                    ? t("actions.activate", {ns: "common"})
                                                    : t("actions.inactivate", {ns: "common"})}
                                            </LeftButton>
                                        </Tooltip>
                                    )}
                                </Col> */}
                                {stores.meStore.checkRole("listCourierOnboarding") && (
                                    <Col>
                                        <CourierOnboardingActionButtons
                                            courier={courierData?.data}
                                            reloadCourier={reloadCourier}
                                            isTabActive={true}
                                            courierLoading={loading}
                                        />
                                    </Col>
                                )}
                            </Row>
                        )
                    }
                >
                    <Tabs.TabPane
                        tab={<span data-testid="courierInformationTab">{"Kurye Detay"}</span>}
                        key="courierInformationTab"
                    >
                        {!courierData.data ? (
                            <Skeleton
                                paragraph={{rows: 10, width: "100%"}}
                                active={true}
                            ></Skeleton>
                        ) : (
                            <>
                                <ChangePasswordModal
                                    title={t("courierResetPasswordModalTitle", {
                                        ns: "courierResetPasswordModal"
                                    })}
                                    isVisible={visibleChangePasswordModal}
                                    updateCourierPassword={values => updateCourierPassword(values)}
                                    setVisible={() => {
                                        setVisibleChangePasswordModal(!visibleChangePasswordModal);
                                    }}
                                />
                                <CourierStatusUpdateModal
                                    isVisible={visibleStatusModal}
                                    setVisible={() => {
                                        setVisibleStatusModal(!visibleStatusModal);
                                    }}
                                    unavailable
                                    defaultStatus={courierData.data?.location?.status || ""}
                                    courierId={courierId}
                                    hasDelivery={!!currentDelivery}
                                    updateStatus={values => updateStatus(values)}
                                />

                                <Descriptions
                                    column={{xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1}}
                                    title={
                                        <>
                                            <TopContainer
                                                justify="space-around"
                                                data-testid="courierCompanyDataCard"
                                            >
                                                <Col span={24} sm={10} md={8} lg={4} xl={7} xxl={7}>
                                                    <PhotoTabs
                                                        defaultActiveKey="profilePhoto"
                                                        size="small"
                                                    >
                                                        <Tabs.TabPane
                                                            tab={t("photoTabs.profile", {
                                                                ns: "courierDetail"
                                                            })}
                                                            key="profilePhoto"
                                                        >
                                                            <ImageWrapper>
                                                                <ImageProfile
                                                                    src={profilePhotoSrc}
                                                                    alt="courier profile"
                                                                />
                                                                {profilePictureUrl && (
                                                                    <Overlay className="overlay">
                                                                        <VFlex
                                                                            vertical
                                                                            gap={12}
                                                                            align="center"
                                                                        >
                                                                            <CourierDocumentsDownload
                                                                                courierId={
                                                                                    courierId
                                                                                }
                                                                                documentType={
                                                                                    "profilePicture"
                                                                                }
                                                                            />
                                                                        </VFlex>
                                                                    </Overlay>
                                                                )}
                                                            </ImageWrapper>
                                                            {!profilePictureUrl && (
                                                                <Row
                                                                    justify="center"
                                                                    style={{marginTop: 8}}
                                                                >
                                                                    <Col>
                                                                        <Tag color="warning">
                                                                            {t("noProfilePhoto", {
                                                                                ns: "courierDetail"
                                                                            })}
                                                                        </Tag>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </Tabs.TabPane>
                                                        <Tabs.TabPane
                                                            tab={t("photoTabs.getir", {
                                                                ns: "courierDetail"
                                                            })}
                                                            key="getirPhoto"
                                                        >
                                                            <ImageWrapper>
                                                                <ImageProfile
                                                                    src={
                                                                        getirPictureUrl ||
                                                                        placeholder
                                                                    }
                                                                    alt="courier getir profile"
                                                                />
                                                                {(getirPictureUrl ||
                                                                    (canManageGetirPicture &&
                                                                        basePhotoForGetirCreation)) && (
                                                                    <Overlay className="overlay">
                                                                        <VFlex
                                                                            vertical
                                                                            gap={12}
                                                                            align="center"
                                                                        >
                                                                            {canManageGetirPicture &&
                                                                                basePhotoForGetirCreation && (
                                                                                    <CreateGetirPicture
                                                                                        photoUrl={
                                                                                            basePhotoForGetirCreation
                                                                                        }
                                                                                        courierTckn={
                                                                                            courierTckn
                                                                                        }
                                                                                        courierId={
                                                                                            courierId
                                                                                        }
                                                                                        getirImageUrl={
                                                                                            getirPictureUrl
                                                                                        }
                                                                                        buttonText={
                                                                                            getirPictureUrl
                                                                                                ? t(
                                                                                                      "actions.regenerateGetirPicture",
                                                                                                      {
                                                                                                          ns:
                                                                                                              "courierDetail"
                                                                                                      }
                                                                                                  )
                                                                                                : t(
                                                                                                      "actions.generateGetirPicture",
                                                                                                      {
                                                                                                          ns:
                                                                                                              "courierDetail"
                                                                                                      }
                                                                                                  )
                                                                                        }
                                                                                        onCompleted={() =>
                                                                                            reloadCourier()
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            {getirPictureUrl && (
                                                                                <Button
                                                                                    type="primary"
                                                                                    shape="round"
                                                                                    size="middle"
                                                                                    onClick={() =>
                                                                                        handleDownloadGetirImage(
                                                                                            getirPictureUrl,
                                                                                            `getir-gorsel-${courierTckn}.png`
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {t(
                                                                                        "actions.downloadGetirPicture",
                                                                                        {
                                                                                            ns:
                                                                                                "courierDetail"
                                                                                        }
                                                                                    )}
                                                                                </Button>
                                                                            )}
                                                                        </VFlex>
                                                                    </Overlay>
                                                                )}
                                                            </ImageWrapper>
                                                            {!getirPictureUrl && (
                                                                <Row
                                                                    justify="center"
                                                                    style={{marginTop: 8}}
                                                                >
                                                                    <Col>
                                                                        <Tag color="warning">
                                                                            {t("noGetirPhoto", {
                                                                                ns: "courierDetail"
                                                                            })}
                                                                        </Tag>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </Tabs.TabPane>
                                                    </PhotoTabs>
                                                    <Row
                                                        justify="center"
                                                        data-testid="courierName"
                                                        style={{marginBottom: "16px"}}
                                                    >
                                                        {courierData.data.fullname}
                                                    </Row>
                                                    <CourierPersonalInfoContainer gutter={[12, 12]}>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    Vatandaşlık Durumu
                                                                </div>
                                                                <div className="info-value">
                                                                    {courierData.data.isCitizen
                                                                        ? "T.C. Vatandaşı"
                                                                        : "Yabancı"}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    Kimlik Numarası
                                                                </div>
                                                                <div className="info-value">
                                                                    {courierData.data.tckn}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    Telefon
                                                                </div>
                                                                <div className="info-value">
                                                                    {formatPhoneNumber(
                                                                        courierData.data.cellPhone
                                                                    )}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    Doğum Tarihi
                                                                </div>
                                                                <div className="info-value">
                                                                    {courierData?.data?.birthDate
                                                                        ? moment(
                                                                              courierData.data
                                                                                  .birthDate
                                                                          )
                                                                              .locale(
                                                                                  i18n.resolvedLanguage ||
                                                                                      "tr"
                                                                              )
                                                                              .format("ll")
                                                                        : "-"}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    Sürücü Belgesi
                                                                </div>
                                                                <div className="info-value">
                                                                    {courierData.data?.drivingLicenses
                                                                        ?.map(
                                                                            drivingLicense =>
                                                                                drivingLicense
                                                                                    ?.label.tr
                                                                        )
                                                                        ?.join(", ") || "-"}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    Cinsiyet
                                                                </div>
                                                                <div className="info-value">
                                                                    {courierData?.data?.gender
                                                                        ? t(
                                                                              `fields.${courierData.data.gender}`,
                                                                              {
                                                                                  ns: "common"
                                                                              }
                                                                          )
                                                                        : "-"}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    {t("fields.bloodGroup", {
                                                                        ns: "common"
                                                                    })}
                                                                </div>
                                                                <div className="info-value">
                                                                    {courierData?.data
                                                                        ?.bloodGroup || "-"}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    P1* Belgesi Durumu
                                                                </div>
                                                                <div className="info-value">
                                                                    {typeof courierData.data
                                                                        .hasP1Certificate ===
                                                                    "boolean"
                                                                        ? courierData.data
                                                                              .hasP1Certificate
                                                                            ? "Var"
                                                                            : "Yok"
                                                                        : "-"}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={16}
                                                            lg={12}
                                                            xl={8}
                                                        >
                                                            <PersonalInfoCard>
                                                                <div className="info-label">
                                                                    Çalışmak İstenen İl
                                                                </div>
                                                                <div className="info-value">
                                                                    {courierData.data.preferredCity
                                                                        ?.name || "-"}
                                                                </div>
                                                            </PersonalInfoCard>
                                                        </CourierPersonalInfoItem>
                                                        <CourierPersonalInfoItem
                                                            xs={24}
                                                            md={12}
                                                            lg={24}
                                                        >
                                                            <Tooltip
                                                                title={courierData.data.preferredDistricts
                                                                    ?.map(
                                                                        district => district?.name
                                                                    )
                                                                    .join(", ")}
                                                            >
                                                                <PersonalInfoCard>
                                                                    <div className="info-label">
                                                                        Çalışmak İstenen İlçe(ler)
                                                                    </div>
                                                                    <div className="info-value">
                                                                        {courierData.data.preferredDistricts
                                                                            ?.map(
                                                                                district =>
                                                                                    district?.name
                                                                            )
                                                                            .join(", ") || "-"}
                                                                    </div>
                                                                </PersonalInfoCard>
                                                            </Tooltip>
                                                        </CourierPersonalInfoItem>
                                                    </CourierPersonalInfoContainer>
                                                </Col>
                                                {stores.meStore.checkRole(
                                                    "notVisibleForCompanyUser"
                                                ) && (
                                                    <Col
                                                        span={24}
                                                        sm={14}
                                                        md={16}
                                                        lg={8}
                                                        xl={8}
                                                        xxl={8}
                                                    >
                                                        <SelectContainer
                                                            align="center"
                                                            justify="center"
                                                            style={{width: "100%"}}
                                                        >
                                                            <Col
                                                                data-testid="courierComponySelectCard"
                                                                style={{width: "100%"}}
                                                            >
                                                                <MultipleSelect
                                                                    direction={"vertical"}
                                                                    data={courierData.data}
                                                                    disabled={disableEditDedication}
                                                                    list={[
                                                                        {
                                                                            key: "company",
                                                                            value: t(
                                                                                "fields.company",
                                                                                {
                                                                                    ns: "common"
                                                                                }
                                                                            ),
                                                                            width: "100%"
                                                                        },
                                                                        {
                                                                            key: "subcompany",
                                                                            value: t(
                                                                                "fields.subcompany",
                                                                                {ns: "common"}
                                                                            ),
                                                                            width: "100%"
                                                                        },
                                                                        {
                                                                            key: "slotCourier",
                                                                            value: t(
                                                                                "fields.slotCourier",
                                                                                {ns: "common"}
                                                                            ),
                                                                            width: "100%"
                                                                        },
                                                                        {
                                                                            key: "projectInfo",
                                                                            value: "Proje Bilgisi",
                                                                            width: "100%"
                                                                        }
                                                                    ]}
                                                                    onChange={
                                                                        onChangeMultipleSelect
                                                                    }
                                                                />
                                                            </Col>
                                                        </SelectContainer>
                                                        {stores.meStore.checkRole(
                                                            "assignCourier"
                                                        ) &&
                                                            stores.meStore.checkPermission(
                                                                "couriers.edit"
                                                            ) && (
                                                                <Row justify="end">
                                                                    {disableEditDedication ? (
                                                                        <EditButton
                                                                            type="primary"
                                                                            data-testid="editButton"
                                                                            onClick={() =>
                                                                                setDisableEditDedication(
                                                                                    false
                                                                                )
                                                                            }
                                                                            icon={<EditOutlined />}
                                                                        >
                                                                            {t("actions.edit", {
                                                                                ns: "common"
                                                                            })}
                                                                        </EditButton>
                                                                    ) : (
                                                                        <Button
                                                                            type="danger"
                                                                            data-testid="saveCompanyInformationButton"
                                                                            onClick={() => {
                                                                                stores.appStore.openConfirmModal(
                                                                                    {
                                                                                        title: t(
                                                                                            "modal.confirmTitle",
                                                                                            {
                                                                                                ns:
                                                                                                    "common"
                                                                                            }
                                                                                        ),
                                                                                        content: t(
                                                                                            "modal.wantToChangeDedication",
                                                                                            {
                                                                                                ns:
                                                                                                    "courierDetail"
                                                                                            }
                                                                                        ),
                                                                                        okButtonProps: {
                                                                                            "data-testid":
                                                                                                "sureButton"
                                                                                        },
                                                                                        cancelButtonProps: {
                                                                                            "data-testid":
                                                                                                "cancelButton"
                                                                                        },
                                                                                        onOk: async () => {
                                                                                            setCourierSelectData();
                                                                                            setDisableEditDedication(
                                                                                                true
                                                                                            );
                                                                                            await stores.courierStore.courierUpdateDedication(
                                                                                                {
                                                                                                    ...courierSelectData,
                                                                                                    courierId
                                                                                                }
                                                                                            );
                                                                                            await setRecall(
                                                                                                !recallRef.current
                                                                                            );
                                                                                        }
                                                                                    }
                                                                                );
                                                                            }}
                                                                            icon={<CheckOutlined />}
                                                                            disabled={
                                                                                !courierSelectData
                                                                            }
                                                                        >
                                                                            {t("actions.save", {
                                                                                ns: "common"
                                                                            })}
                                                                        </Button>
                                                                    )}
                                                                </Row>
                                                            )}
                                                    </Col>
                                                )}
                                            </TopContainer>
                                        </>
                                    }
                                    bordered
                                ></Descriptions>
                                <Row type="flex" style={{marginTop: "16px", marginBottom: "16px"}}>
                                    <Col span={24}>
                                        <CourierOnboardingTab
                                            courier={courierData?.data || {}}
                                            courierLoading={loading}
                                            reloadCourier={reloadCourier}
                                        />
                                    </Col>
                                </Row>
                                <Row type="flex" justify="end"></Row>
                            </>
                        )}
                    </Tabs.TabPane>

                    {stores.meStore.checkRole("listCourierShifts") &&
                        stores.meStore.checkPermission("couriers.shifts") && (
                            <Tabs.TabPane
                                key="shiftsTab"
                                tab={<span>{t("tabs.shifts", {ns: "courierDetail"})}</span>}
                            >
                                <ShiftTable courierId={courierId} />
                            </Tabs.TabPane>
                        )}
                    {stores.meStore.checkRole("listCourierHistory") &&
                        stores.meStore.checkPermission("couriers.statusHistory") && (
                            <Tabs.TabPane
                                key="historyTab"
                                tab={
                                    <span data-testid="historyTab">
                                        {isAgency
                                            ? t("tabs.historyTabAgency", {ns: "courierDetail"})
                                            : "Durum Geçmişi"}
                                    </span>
                                }
                            >
                                <HistoryTab
                                    courierData={courierData?.data}
                                    courierLoading={loading}
                                    setCourierLogs={setCourierLogs}
                                    courierLogs={courierLogs}
                                    setOrderInfoVisible={setOrderInfoVisible}
                                    courierStatus={courierStatus}
                                    orderInfoVisible={orderInfoVisible}
                                    dateRange={dateRange}
                                    setDateRange={setDateRange}
                                    courierId={courierId}
                                    setVisibleStatusModal={setVisibleStatusModal}
                                    isMobile={isMobile}
                                />
                            </Tabs.TabPane>
                        )}
                    {stores.meStore.checkRole("listCourierStatusHistory") &&
                        stores.meStore.checkPermission("couriers.onboardingStatusHistory") && (
                            <Tabs.TabPane
                                key="statusHistoryTab"
                                tab={
                                    <span data-testid="statusHistoryTab">
                                        {t(
                                            isAgency
                                                ? "tabs.statusHistoryTabAgency"
                                                : "tabs.statusHistoryTab",
                                            {ns: "courierDetail"}
                                        )}
                                    </span>
                                }
                            >
                                <CourierStatusLogTable
                                    loading={onboardingStatusHistoryDataLoading}
                                    data={onboardingStatusHistoryData}
                                    onChange={handleOnboardingStatusHistoryPaginationChange}
                                    courier={courierData.data}
                                />
                            </Tabs.TabPane>
                        )}
                    {stores.meStore.checkRole("listCourierDedicationHistory") && (
                        <Tabs.TabPane
                            key="assignmentHistoryTab"
                            tab={
                                <span data-testid="assignmentHistoryTab">
                                    {t("tabs.assignmentHistoryTab", {ns: "courierDetail"})}
                                </span>
                            }
                        >
                            <LogTable
                                loading={dedicationDataLoading}
                                data={courierDedicationData}
                                onChange={handleDedicationPaginationChange}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("listCourierWallet") &&
                        stores.meStore.checkPermission("couriers.walletView") && (
                            <Tabs.TabPane
                                tab={<span data-testid="courierLatestStatusTab">Cüzdan</span>}
                                key="courierWalletTab"
                            >
                                <CourierWalletTab
                                    isTabActive={tabKey === "courierWalletTab"}
                                    courier={courierData.data}
                                    courierLoading={loading}
                                    reloadCourier={reloadCourier}
                                />
                            </Tabs.TabPane>
                        )}

                    {stores.meStore.checkRole("listCourierCODInfo") &&
                        stores.meStore.checkPermission("couriers.codSettings") && (
                            <Tabs.TabPane
                                tab={<span data-testid="vigoPosTab">{codPaymentBrandLabel}</span>}
                                key="vigoPosTab"
                            >
                                <CourierCodPaymentTab
                                    courier={courierData.data}
                                    courierLoading={loading}
                                    reloadCourier={reloadCourier}
                                />
                            </Tabs.TabPane>
                        )}
                    {stores.meStore.checkPermission("couriers.contracts") && (
                        <Tabs.TabPane
                            tab={<span data-testid="courierContractsTab">Sözleşmeler</span>}
                            key="courierContractsTab"
                        >
                            <CourierContractsTab
                                courierId={courierId}
                                courierData={courierData.data}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("ticketAccess") &&
                        stores.meStore.checkPermission("couriers.tickets") && (
                            <Tabs.TabPane
                                tab={<span data-testid="courierTicketsTab">Talepler</span>}
                                key="courierTicketsTab"
                            >
                                <OwnerTicketsTab
                                    category="courier"
                                    ownerId={courierId}
                                    ownerName={courierData.data?.fullname}
                                    isTabActive={tabKey === "courierTicketsTab"}
                                />
                            </Tabs.TabPane>
                        )}
                </TabsContainer>
            </>
        );
    });
};
